import { useState, useEffect } from 'react';
import Hero from './components/Hero';
import BeforeAfter from './components/BeforeAfter';
import Problem from './components/Problem';
import Solution from './components/Solution';
import Process from './components/Process';
import Reviews from './components/Reviews';
import LeadForm from './components/LeadForm';
import Footer from './components/Footer';

export default function Home() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToForm = () => {
    const formSection = document.getElementById('audit-form');
    if (formSection) {
      formSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div className="bg-[#0A0A0A] text-white">
      {/* Fixed Navigation */}
      <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? 'bg-[#0A0A0A]/95 backdrop-blur-sm shadow-lg' : 'bg-transparent'}`}>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 py-3 sm:py-4 flex items-center justify-between gap-2">
          <div className="flex items-center gap-2 sm:gap-3 min-w-0 flex-shrink">
            <img src="https://static.readdy.ai/image/68c02a6c7db1e4f446ae7031426f220f/48a0b6b9e68cfbf8d21754fa0f3ebce1.png" alt="ServiceBizLab" className="h-8 sm:h-10 w-auto flex-shrink-0" />
            <span className="text-base sm:text-xl font-bold truncate">ServiceBizLab</span>
          </div>
          <button 
            onClick={scrollToForm}
            className="bg-[#3B82F6] text-white px-3 sm:px-6 py-2 sm:py-3 rounded-lg text-sm sm:text-base font-bold hover:bg-[#2563EB] transition-all whitespace-nowrap cursor-pointer flex-shrink-0"
          >
            Get Free Mockup
          </button>
        </div>
      </nav>

      <Hero onCtaClick={scrollToForm} />
      <BeforeAfter />
      <Problem />
      <Solution />
      <Process />
      <Reviews />
      <LeadForm />
      <Footer />
    </div>
  );
}
